import { render } from "./UserProfileView.vue?vue&type=template&id=60729874"
import script from "./UserProfileView.vue?vue&type=script&lang=js"
export * from "./UserProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__